import React from "react";
import {NavBarHome, NavLi, WrapperUl} from "./styleHome";
import {Link} from "react-scroll";
import wavecodeLogo from "../imagens/apple-touch-icon.png";

export const NavBar = () => {
    return (
        <NavBarHome>
            <div
                style={{
                    display: "flex",
                    justifyItems: "center",
                    justifyContent: "center",
                    color: "white",
                    alignItems: "center",
                    fontSize: "20px"
                }}
            >
                <img
                    src={wavecodeLogo}
                    alt={"wavecode"}
                    width={"35px"}
                    style={{marginRight: "10px"}}
                />
                <div>
                    <span style={{fontSize: "19px"}}>PLATAFORMA</span> <b>WAVECODE</b>
                </div>
            </div>

            <WrapperUl>
                <Link
                    to="home"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <NavLi>INÍCIO</NavLi>
                </Link>

                <Link
                    to="empresa"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <NavLi>PLATAFORMA</NavLi>
                </Link>

                <Link
                    to="editais"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <NavLi>EDITAIS </NavLi>
                </Link>

                <Link
                    to="proposta"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <NavLi>PROPOSTA </NavLi>
                </Link>

                <Link
                    to="licitacoes"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <NavLi>LICITAÇÕES </NavLi>
                </Link>


                <Link
                    activeClass="active"
                    to="monitoramento"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <NavLi>MONITORAMENTO</NavLi>
                </Link>

                <Link to="disputa" spy={true} smooth={true} offset={0} duration={500}>
                    <NavLi>DISPUTA </NavLi>
                </Link>

                <Link
                    to="contato"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    <NavLi>CONTATO</NavLi>
                </Link>

                <a
                    href={"https://oferta.wavecode.com.br/plataforma-wavecode"}
                    target={"_blank"}
                >
                    <NavLi background={"#0496cf"}>TESTE GRÁTIS</NavLi>
                </a>
            </WrapperUl>
        </NavBarHome>
    );
};
